export const sxStyled = theme => ({
  cardGrid: {
    borderRadius: '10px',
    height: 'auto',
    width: 'auto',
    marginButton: '30px',
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: '#fff',
    border: {
      xs: '2px solid #E5E5E5',
      sm: 'none',
    },
    margin: {
      xs: '10px 20px',
      sm: 'auto',
    },
  },
  cardContent: {
    height: '100%',
    width: '100%',
  },
  centerItems: {
    width: '95%',
    marginLeft: 'auto',
    marginRight: 'auto',
  },
  clusterDateContainer: {
    display: 'flex',
    flexWrap: 'nowrap',
    alignItems: 'center',
    justifyContent: {
      xs: 'flex-start',
      sm: 'space-evenly',
    },
    marginLeft: {
      xs: '2.5rem',
      sm: '0',
    },
  },
  clusterTitles: {
    fontWeight: '600',
    color: '#000000',
    fontSize: {
      xs: '16px',
      lg: '15px',
      xl: '16px',
    },
  },
  titleType: {
    fontSize: '16px',
    color: theme.tertiary,
    marginRight: '8px',
  },
  hideOnMobile: {
    display: {
      xs: 'none',
      md: 'block',
    },
  },
  clusterDestinationContainer: {
    display: 'flex',
    alignItems: 'center',
    paddingLeft: '8px',
    padding: {
      xs: '0',
      sm: '8px',
    },
    justifyContent: {
      xs: 'flex-start',
      sm: 'flex-start',
    },
    marginLeft: {
      xs: '2.5rem',
      sm: '0',
    },
  },
  separatorVertical: {
    height: '100%',
    width: '1px',
    backgroundColor: 'rgba(34, 34, 34, 0.2)',
  },
  pagesButton: {
    width: '30%',
    fontSize: '14px',
    fontWeight: 600,
    backgroundColor: theme.primary,
    borderRadius: '8px',
    color: theme.text1,
    marginBottom: '2vh',

    '&:hover': {
      backgroundColor: theme.primary,
      color: theme.text1,
    },

    '&.Mui-disabled': {
      backgroundColor: theme.primary,
      color: theme.text1,
      opacity: 0.4,
      cursor: 'not-allowed',
      pointerEvents: 'auto',
    },
  },
  compartirButton: {
    width: '100%',
    fontSize: '16px',
    fontWeight: '600',
    border: 'none',
    color: theme.tertiary,
    '&:hover': {
      background: 'none',
    },
  },
  visibility: {
    visibility: 'collapse',
    marginTop: '15px',
  },
  gridClusterItem: {
    padding: {
      xs: '0px',
      sm: '8px',
    },
  },
  boxClusterTitleIda: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: {
      xs: '25px',
      sm: '30px',
    },
    padding: '5px 0.8vw',
  },
  boxSalida: {
    marginTop: '2vh',
    display: {
      xs: 'none',
      sm: 'flex',
    },
    alignItems: 'center',
    padding: '0',
    marginBottom: '-10px',
  },
  isScroll: {
    overflowY: 'scroll',
    padding: '0 5px 0 1px',
    height: {
      xs: '440px',
      sm: '600px',
    },
    '&::-webkit-scrollbar': {
      width: '10px',
    },
    '&::-webkit-scrollbar-thumb:hover': {
      backgroundColor: '#5725ff',
    },
    '&::-webkit-scrollbar-thumb': {
      backgroundColor: '#bcbcbc',
      border: '2px solid #f0f0f0',
    },
    '&::-webkit-scrollbar-track': {
      backgroundColor: '#f0f0f0',
    },
  },
});
